export function query(selector: string, parent?: HTMLElement) {
  const target = parent || document
  return target.querySelector(selector) as HTMLElement
}

export function addClass(target: HTMLElement, className: string) {
  return target.classList.add(className)
}

export function removeClass(target: HTMLElement, className: string) {
  return target.classList.remove(className)
}

export function hasClass(target: HTMLElement, className: string) {
  return target.classList.contains(className)
}

export function toggleClass({
  target,
  stateType,
  stateClassNames,
  isDirect
}: {
  target: HTMLElement;
  stateType: 'add' | 'remove';
  stateClassNames?: {
    add?: string,
    remove?: string
  };
  isDirect?: boolean;
}) {
  const classNameToogleObj: {
    add: string;
    remove: string;
  } = {
    add: 'none',
    remove: 'none'
  }
  // 注意 isDirect = true， stateType 取相反直接做删除或者增加class； isDirect = false add、remove为展示或者消失
  const state: 'add' | 'remove' = isDirect ? stateType === 'add' ? 'remove' : 'add' : stateType
  if (state === 'add') {
    removeClass(target, stateClassNames ? stateClassNames[stateType] : classNameToogleObj[stateType])
  } else {
    addClass(target, stateClassNames ? stateClassNames[stateType] : classNameToogleObj[stateType])
  }
}

export function timeRangeToArray(timeRanges) {
  let ranges = []

  for (let i = 0; i < timeRanges.length; ++i)
    ranges = [...ranges, [timeRanges.start(i), timeRanges.end(i)]]

  return ranges
}
